<div class="container-fluid bg-white">
  <div class="row">
    <div class="sidebar border border-right col-md-3 col-lg-2 p-0 bg-body-tertiary">
      <div class="d-flex flex-column flex-shrink-0 p-3 bg-body-tertiary" style="width: 100%;">
        <!-- Filter Label-->
        <div href="/" class="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-body-emphasis text-decoration-none pb-4">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
          </svg>
          <span class="fs-6">&nbsp; Filters </span>
        </div>
        <!-- Filter Options -->
        <ul class="nav nav-pills flex-column mb-auto">
          <li class="nav-item" role="presentation">
            <div class="nav">
              <div class="form-floating mb-3" style="width: 100%;">
                <select class="form-select" aria-label="Filter by company" id="company" [(ngModel)]="this.reviewsSearch.companyNumber">
                  <option></option>
                  @for (company of this.companies; track company.id) {
                  <option value="{{company.id}}">{{company.name}}</option>
                  }
                </select>
                <label for="company">Company:</label>
              </div>
            </div>
          </li>
          <li class="nav-item" role="presentation">
            <div class="nav">
              <div class="form-floating mb-3" style="width: 100%;">
                <input class="form-control" id="project" [(ngModel)]="this.reviewsSearch.projectId">
                <label for="project">Project:</label>
              </div>
            </div>
          </li>
          <li class="nav-item" role="presentation">
            <div class="nav">
              <div class="form-floating mb-3" style="width: 100%;">
                <input class="form-control" id="name" [(ngModel)]="this.reviewsSearch.projectName">
                <label for="name">Name:</label>
              </div>
            </div>
          </li>
          <li class="nav-item" role="presentation">
            <div class="nav">
              <div class="form-floating input-group mb-3" style="width: 100%;">
                <input class="form-control" placeholder="mm-dd-yyyy" ngbDatepicker #sd="ngbDatepicker" [(ngModel)]="this.reviewsSearch.startDate" />
                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="sd.toggle()" type="button" style="border-color: rgb(222, 226, 230);"></button>
                <label for="status">Start Date:</label>
              </div>
            </div>
          </li>
          <li class="nav-item" role="presentation">
            <div class="nav">
              <div class="form-floating input-group mb-3" style="width: 100%;">
                <input class="form-control" placeholder="mm-dd-yyyy" ngbDatepicker #ed="ngbDatepicker" [(ngModel)]="this.reviewsSearch.endDate" />
                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ed.toggle()" type="button" style="border-color: rgb(222, 226, 230);"></button>
                <label for="status">End Date:</label>
              </div>
            </div>
          </li>
          <li class="nav-item" role="presentation">
            <div class="nav">
              <div class="form-floating mb-3" style="width: 100%;">
                <select class="form-select" aria-label="Filter by company" id="status" [(ngModel)]="this.reviewsSearch.status">
                  <option></option>
                  <option value="Not Started">Not Started</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Completed">Completed</option>
                </select>
                <label for="status">Status:</label>
              </div>
            </div>
          </li>
          <li class="nav-item" role="presentation">
            <div class="nav">
              <div style="width: 100%; text-align: right;">
                <button type="button" class="btn btn-sm  btn-outline-primary" (click)="this.onClearClick()" [disabled]="this.isLoading">Clear</button>&nbsp;
                <button type="button" class="btn btn-sm btn-primary" (click)="this.onFilterClick()" [disabled]="this.isLoading">Filter</button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <main class="col-md-9 ms-sm-auto col-lg-10 px-md-4" style="padding-right: 12px !important; height: calc(100vh - 64px);">
      <!-- Header -->
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 border-bottom">
        <h1 class="h2" style="white-space: nowrap;">Reviews</h1>
        @if(this.isLoading){
        <div class="spinner-border" role="status" style="margin-right: 8px;">
          <span class="sr-only"></span>
        </div>
        }
      </div>
      <div class="tab-content" id="myTabContent">
        <!-- Sections -->
        <div class="row">
          <div class="table-responsive col-12" style="margin-right: 0px; padding-left: 16px; margin-top: 16px; overflow: hidden scroll; max-height: calc(-240px + 100vh);">
            <table class="table table-striped table-hover">
              <thead class="sticky-top-header">
                <tr>
                  <th scope="col">Company</th>
                  <th scope="col">Project</th>
                  <th scope="col">Name</th>
                  <th scope="col">Flags</th>
                  <th scope="col">Date</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
                @for (review of this.reviews?.results; track review.id) {
                <tr (click)="this.onRowClick(review.id)" style="cursor: pointer;">
                  <td>{{review.companyNumber}}</td>
                  <td>{{review.projectId}}</td>
                  <td>{{review.projectName}}</td>
                  <td>{{review.flagCount}}</td>
                  <td>{{review.issuedDate | date: 'MM/dd/yyyy' : 'UTC'}}</td>
                  <td>{{review.status}}</td>
                </tr>
                } @empty {
                <tr>
                  <td colspan="6" style="text-align: center;">
                    @if (this.isLoading){
                    Loading...
                    } @else {
                    No Reviews
                    }
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
          <div class="col-12" style="padding-top: 8px; border-top: 1px solid lightgray;">
            <div class="d-flex justify-content-between p-2">
              @if (this.reviews?.resultCounts){
              <ngb-pagination [collectionSize]="this.ReviewSearchResult(this.reviewSearchResultCounts.count, 0)" [page]="this.ReviewSearchResult(this.reviewSearchResultCounts.page, 1)" [pageSize]="this.size" [maxSize]="5" [ellipses]="true" [boundaryLinks]="true" [rotate]="true" (pageChange)="this.onPageChange($event)" />
              <select class="form-select" style="width: auto" [(ngModel)]="this.size" (change)="this.onSizeChange()">
                <option [ngValue]="10">10 items per page</option>
                <option [ngValue]="25">25 items per page</option>
                <option [ngValue]="50">50 items per page</option>
              </select>
              }
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</div>
